<template>
  <div class="dataIndex">
    <!-- <img src="./../../../assets/img/work/open/tj.png" alt=""> -->
    <div>
      <!-- 类型选择 -->
      <div class="dataTypeBox">
        <div
          v-for="(item,index) in dataList"
          :key="index"
          @click="switchType(index)"
          :class="{active:index==nowClickIndex}"
        >{{item.val}}</div>
      </div>
      <!-- 内容区域 -->
      <div class="mainContent">
        <!-- 今日统计 -->
        <todayAcountPart v-if="nowClickIndex==0" />
        <!-- 销售统计 -->
        <saleAcount v-if="nowClickIndex==1" />
        <!-- 赊欠统计 -->
        <creditAcount v-if="nowClickIndex==2" />
      </div>
    </div>
  </div>
</template>

<script>
import todayAcountPart from "./todayAcountPart/todayAcount";
import saleAcount from "./saleAcountPart/saleAcount";
import creditAcount from "./creditAcountPart/creditAcount";
export default {
  name: "dataIndex",
  components: {
    todayAcountPart,
    saleAcount,
    creditAcount,
  },
  data() {
    return {
      dataList: [
        { index: 0, val: "今日统计" },
        { index: 1, val: "销售统计" },
        { index: 2, val: "赊还统计" },
      ],
      nowClickIndex: 0, //
    };
  },
  created() {},
  mounted() {},
  methods: {
    //头部统计类型选择
    switchType(index) {
      this.nowClickIndex = index;
      this.nowSalesManage = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.dataIndex {
  position: relative;
  height: 100%;
  padding: 0 0.1rem;
  > div {
    display: flex;
    flex-direction: column;
    height: 100%;
    .dataTypeBox {
      display: flex;
      align-items: flex-end;
      margin-left: 0.2rem;
      background: #e4e4e4;
      width: 100%;
      height: 0.64rem;
      box-sizing: border-box;
      position: fixed;
      top: 0.54rem;
      div {
        width: 1.1rem;
        text-align: center;
        margin-right: 0.1rem;
        height: 0.54rem;
        line-height: 0.54rem;
        background: #fff;
        border-radius: 0.04rem;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        font-size: 0.2rem;
        color: #333;
        background: #eeeeee;
      }
      .active {
        color: #31b158;
        background: #fff;
      }
    }
    .mainContent {
      margin-top: 0.64rem;
      flex: 1;
      height: calc(100% - 0.64rem);
    }
  }
}
</style>